import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AddToWishlistContext } from './AddToWishlistContext';
import CartItem from '../add-to-cart/CartItem';

import '../buttons/WishlistSharingButton.css'
import WishlistSharingButton from '../buttons/WishlistSharingButton';
import { isMobileDevice } from "../../../utils/DeviceDetector";
import { getMobileOS } from 'web-store-modules/packages/obsess-device-detector';
import ReactHtmlParser from 'react-html-parser';
import CartDropdownFooter from '../add-to-cart/CartDropdownFooter';
import { Email, WishlistCheckoutButtonClicked, WishlistShareButtonClicked, WhatsAppWishlistButtonAnalytics } from '../../../utils/Analytics';
import WishlistEmailModal from '../modals/wishlist-email/WishlistEmailModal';
import { withTranslation } from 'react-i18next';

const isMobile = isMobileDevice();
const preCheckoutURL = 'https://test.ferragamo.com/shop/us/en/mycart?addItems=';
const whatsappIcon = 'https://cdn.obsess-vr.com/mary-kay/Whatsapp.png';
const emailIcon = 'https://cdn.obsess-vr.com/mary-kay/Email.png';
const shareIcon = "https://cdn.obsess-vr.com/ferragamo/share2.svg";

const WishlistDropdown = ({ showDropdown, menuTextFontStyle, wishlistFontStyle, wishList, currentLanguage, currentSceneName, t }) => {
    const { pricePrefix, removeFromWishlist } = useContext(AddToWishlistContext);
    const [showShareIcon, setShowShareIcon] = useState(false);
    const [showEmailAcqModal, setShowEmailAcqModal] = useState(false)
    
    const popupFormHandler = (type) => {
        if (type === t('wishlistCartDropdown4')) {
            Email();
            setShowEmailAcqModal(true);
        }
    }
    const placeOrderUrl = () => {
        const langUrl = (currentLanguage === 'kor_kr') ? 'kor/ko' : currentLanguage.replace('_', '/');
        let urlStr = `https://www.ferragamo.com/shop/${langUrl}/mycart?addItems=`;
        wishList.map((item, index) => {
            const sep = ((index+1) < wishList.length) ? ';' : '';
            urlStr += `${item.SKU},1${sep}`
        });
        WishlistCheckoutButtonClicked();
        const suffixUrl = "&utm_source=houseofgift&utm_medium="+currentLanguage+"&utm_campaign=holiday21&utm_content="+currentSceneName+"_wishlist";
        window.open(urlStr+suffixUrl, '_blank');
    }

    useEffect(() => {
        if(showShareIcon) {
            WishlistShareButtonClicked(); 
        }
    }, [showShareIcon])

    const renderCartItems = () => {
        return (
            <div className='cart-dropdown-item-container'>
                {wishList.map((item, index) => {
                    return (
                        <CartItem
                            key={index}
                            sku={item.SKU}
                            name={item.TITLE}
                            price={item.PRICE}
                            size={item.SIZE}
                            pricePrefix={pricePrefix}
                            prefix={pricePrefix}
                            thumbnail={item.DOWNSIZED_THUMBNAIL}
                            menuTextFontStyle={menuTextFontStyle}
                            removeFromCart={removeFromWishlist}
                            quantity={item.QTY}
                            currentLanguage={currentLanguage}
                            isCartDropDown={false}
                        />
                    )
                })}
            </div>
        );
    }

    const renderSharingButtons = () => {
        const wishListEmail = wishList.map(item => {
            return `   ` + ReactHtmlParser(item.TITLE) + `  ` + item.PRICE;
        })

        const wishListContent = wishList.map(item => {
            return `\n${t('whatsApp2')}:  ` + item.TITLE + `\n${t('whatsApp3')}:  ` + item.PRICE + `\nUrl:  ` + item.URL.replace('_wishlistemail','_wishlistwhatsapp') ;
        })
        const subject = t('whatsApp1');
        const body = `Here’s a list of favorite products from my latest visit to Ferragamo`;

        const emailLink = `mailto:?subject=${subject}&body=${body}` + " " + encodeURIComponent(wishListEmail.join('; ') + ';');
        const whatsappLink = "https://web.whatsapp.com/send?text=" + subject +  encodeURIComponent(wishListContent.join('\n'));
        const whatsappMobileLink = "whatsapp://send?text=" + subject +  encodeURIComponent(wishListContent.join('\n'));
      
        const onShareButtonClicked = () => {
            setShowShareIcon(!showShareIcon);
        }

        return (
            <div style={{ width: 'auto' }}>
                {/* <div className='wishlist-sharing-heading'>{t('wishlistIBCText')}</div> */}
                {/* <div className='wishlist-price-text'>PriceText</div> */}
                <div className="share-panel">
                    <button onClick={onShareButtonClicked} className="call-to-order-btn-wrapper share" style={{ margin: '15px auto',cursor: 'pointer', border:'none', backgroundColor: 'transparent' }} >
                        <img src={shareIcon} style={{ filter: 'invert(1)' }}/>
                    </button>
                    {showShareIcon &&
                        <WishlistSharingButton className="dark-bg" isCentered={true} sharingType={t('wishlistCartDropdown4')} sharingIcon={emailIcon} openPopForm={popupFormHandler} onClick={()=>{}}/>
                    }
                    { showShareIcon &&
                        <WishlistSharingButton className="dark-bg" isCentered={true} sharingType={t('wishlistCartDropdown5')} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLink : whatsappLink} onClick={WhatsAppWishlistButtonAnalytics}/>
                    }
                </div>
             </div>
        );
    }
    const renderWishlistEmailModal = () => {
        return (
            <WishlistEmailModal
                showModal={showEmailAcqModal}
                menuTextFontStyle={menuTextFontStyle}
                onCLoseCallback={e => setShowEmailAcqModal(false)}
            />
        )
    }

    if (!showDropdown) {
        return (<div />);
    }
    return (
        <React.Fragment>
            {renderWishlistEmailModal()}
            {wishList.length !== 0 && <div id='add-to-cart-arrow' />}
            <div id='add-to-cart-menu'>
                {renderCartItems()}
                {wishList.length !== 0 && <CartDropdownFooter onClick={placeOrderUrl}/>}
                {wishList.length !== 0 && renderSharingButtons()}
            </div>
        </React.Fragment>
    );
}

WishlistDropdown.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
};

export default withTranslation()(WishlistDropdown);
